/* global alert */
/* eslint-disable no-alert, no-console */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import axios from 'axios';
import moment from 'moment';

import Heading from '../shared/Heading';
import LabelledSelect from '../shared/LabelledSelect';
import LabelledTextInput from '../shared/LabelledTextInput';
import LabelledDatePicker from '../shared/LabelledDatePicker';
import Schedule from '../Dashboard/components/Schedule';

export default class AdSettings extends Component {
  state = {
    campaignName: '',
    states: [],
    startDate: null,
    endDate: null,
    campaigns: [],
  }

  componentDidMount() {
    const { firstStepValid, history } = this.props;
    if (!firstStepValid) history.push('/upload');

    this.refreshCampaigns();
  }

  refreshCampaigns = () => {
    const endpoint = '/api/ads';
    axios.get(endpoint)
      .then((res) => {
        if (res.status === 200 && res.data.ads) {
          const { ads } = res.data;
          this.setState({ campaigns: ads });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  isValid = () => {
    const {
      campaignName,
      states,
      startDate,
      endDate,
    } = this.state;

    return campaignName.length > 0 && !this.validate('campaignName')
      && states.length > 0 && !this.validate('states')
      && startDate && !this.validate('startDate')
      && endDate && !this.validate('endDate');
  }

  onTextChange = (name) => {
    const { modifyStep } = this.props;
    return (e) => {
      this.setState({
        [name]: e.target.value,
      }, () => {
        modifyStep({ valid: this.isValid(), onNext: this.onNext });
      });
    };
  }

  onSelect = (name) => {
    const { modifyStep } = this.props;
    return (value) => {
      this.setState({
        [name]: value,
      }, () => {
        modifyStep({ valid: this.isValid(), onNext: this.onNext });
      });
    };
  }

  onNext = (callback) => {
    const {
      campaignName,
      states,
      startDate,
      endDate
    } = this.state;

    const { adId } = this.props;

    const endpoint = "/api/ad-settings";

    axios.post(endpoint, {
      campaignName,
      states,
      startDate: moment(startDate).utc(true).format(),
      endDate: moment(endDate).utc(true).format(),
      adId,
      /* eslint-disable-next-line */
    }).then((res) => {
      if (res.status === 200) {
        if (callback) return callback();
        alert('No callback defined');
      } else {
        alert('Error encountered');
      }
    }).catch((err) => {
      const errMessage = err.response && err.response.data && err.response.data.error && err.response.data.error.message;

      if (errMessage && errMessage === 'overlapping times') {
        const overlappingAds = err.response && err.response.data && err.response.data.error && err.response.data.error.overlappingAds;
        return alert(`The following campaigns overlap the desired time & state: ${overlappingAds.map(ad => ad.campaignName).join(', ')}`);
      }

      alert('Error encountered');
    });
  }

  /* eslint-disable-next-line */
  validate = (name) => {
    const {
      startDate,
      endDate,
    } = this.state;

    if (name === 'endDate' && endDate) {
      if (startDate >= endDate) return 'End date must come after start date.';
    }

    return false;
  }

  render() {
    const {
      campaignName,
      states,
      startDate,
      endDate,
      campaigns,
    } = this.state;

    return (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <div style={{ marginRight: 40, height: 500, width: 360 }}>
          <Heading style={{ marginBottom: 7 }}>Campaign settings:</Heading>
          <Description>All times shown in local time</Description>
          <LabelledTextInput
            type="text"
            placeHolder="CAMPAIGN NAME"
            name="campaignName"
            value={campaignName}
            onChange={this.onTextChange('campaignName')}
            errorMessage={this.validate('campaignName')}
          />
          <LabelledSelect
            type="text"
            placeHolder="STATE(S)"
            name="states"
            value={states}
            onChange={this.onSelect('states')}
            isMulti
            options={[
              { label: 'WA', value: 'wa' },
              { label: 'NT', value: 'nt' },
              { label: 'SA', value: 'sa' },
              { label: 'QLD', value: 'qld' },
              { label: 'NSW', value: 'nsw' },
              { label: 'VIC', value: 'vic' },
              { label: 'TAS', value: 'tas' },
              { label: 'ACT', value: 'act' },
            ]}
            errorMessage={this.validate('states')}
          />
          <div style={{ display: 'flex', width: '100%' }}>
            <LabelledDatePicker
              placeHolder="START DATE"
              selected={startDate}
              onSelect={this.onSelect('startDate')}
              onChange={this.onSelect('startDate')}
              errorMessage={this.validate('startDate')}
            />
          </div>
          <div style={{ display: 'flex', width: '100%' }}>
            <LabelledDatePicker
              placeHolder="END DATE"
              selected={endDate}
              onSelect={this.onSelect('endDate')}
              onChange={this.onSelect('endDate')}
              errorMessage={this.validate('endDate')}
            />
          </div>
        </div>
        <div style={{ flex: 3, alignItems: 'flex-start', height: 500 }}>
          <Heading style={{ marginBottom: 7, fontWeight: 400 }}>Upcoming schedule:</Heading>
          <Description>Hover over a campaign to see start and end times</Description>
          <Schedule campaigns={campaigns} small />
        </div>
      </div>
    );
  }
}

const Description = styled.div`
  font-family: 'Karla', sans-serif;
  margin-bottom: 15px;
  font-size: 14px;
  color: #9da1bb;
`;

AdSettings.propTypes = {
  adId: PropTypes.string.isRequired,
  modifyStep: PropTypes.func.isRequired,
  firstStepValid: PropTypes.bool.isRequired,
  history: PropTypes.objectOf({
    push: PropTypes.func.isRequired,
  }).isRequired,
};



// WEBPACK FOOTER //
// ./client/Upload/AdSettings.js